import Api from '.'
import { BaseUrl } from './base_url_enum'
import { ITermsAndCondition } from '../models/terms_and_condition'
import { ILoginApiResponse } from './types/login_api'

interface ITermsApiResponse {
  term: ITermsAndCondition
}

export const getTerms = async (): Promise<ILoginApiResponse<ITermsApiResponse>> => await Api('GET', 'term', BaseUrl.Login)

export const acceptTerms = async (
  termsId: number
): Promise<ILoginApiResponse<ITermsApiResponse>> => await Api('POST', `term/${termsId}/accept`, BaseUrl.Login)

